// extracted by mini-css-extract-plugin
export var fadeIn = "_gp-1";
export var modalContent = "_gp-3";
export var overlay = "_gp-0";
export var popoverContent = "_gp-2";
export var results = "_gp-5";
export var searchInputWrapper = "_gp-4";